import React from 'react';
import get from 'lodash/get';
import Dialog from '../../../core/layout/Dialog';
import Button from '../../../core/form/Button';
import PropTypes from 'prop-types';
import Row from '../../../core/layout/Row';
import Column from '../../../core/layout/Column';
import TextInput from '../../../core/form/TextInput';

const BillCancellationDialog = (props) => {
  return (
    <Dialog
      title={`Bill ${get(props.values, 'billId', null)}`}
      isOpen={props.isOpen}
      onCancel={props.onCancel}
      actions={[
        <Button label="Back" onClick={props.onCancel} loading={props.submitting} key="cancel" />,
        !props.disabled && (
          <Button label="Cancel Bill" onClick={props.onCancelBill} loading={props.submitting} key="cancelBill" />
        ),
      ]}
    >
      {!props.disabled && (
        <Row>
          <Column size={12} style={{ textAlign: 'center' }}>
            <span>This action cannot be undone. Do you really want to cancel this bill?</span>
          </Column>
        </Row>
      )}
      <Row>
        <Column size={6}>
          <TextInput
            disabled={props.submitting || props.disabled}
            label="Cancellation Reason"
            required
            value={get(props.values, 'cancellationReason', null)}
            onChange={(value) => props.onChange('cancellationReason', value)}
            errorText={get(props.errors, 'cancellationReason', '')}
          />
        </Column>
      </Row>
    </Dialog>
  );
};

BillCancellationDialog.propTypes = {
  isOpen: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  errors: PropTypes.object,
  disabled: PropTypes.bool,
  submitting: PropTypes.bool,
  onCancelBill: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

BillCancellationDialog.defaultProps = {
  isOpen: false,
  disabled: false,
  submitting: false,
  errors: {},
};

export default BillCancellationDialog;
